<template>
    <el-checkbox-group v-model="input">
        <el-checkbox v-for="option in options"
                     :label="option.value"
        >
            {{option.label}}
        </el-checkbox>
    </el-checkbox-group>
</template>

<script>

    import CustomInputMixin from '../../mixins/customInput.mixin'

    export default {
        name: 'Amenities',
        mixins: [CustomInputMixin],
        components: {},
        props: {
            options: {
                type: Array,
                default: () => { return [] }
            }
        },
        data() {
            return {
                input: [],
            }
        }

    }

</script>
